import { render, staticRenderFns } from "./feature-list.vue?vue&type=template&id=0860683b&scoped=true"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"
import style0 from "./feature-list.vue?vue&type=style&index=0&id=0860683b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860683b",
  null
  
)

export default component.exports